import Durations from "@/models/Durations";

class NotificationHelperService {
  show(dispatch, message, type, duration) {
    dispatch(
      "notificationModule/showNotification",
      {
        messageAlert: message,
        typeAlert: type,
        duration: duration ? duration : Durations.DefaultNotification,
      },
      { root: true }
    );
  }

  showSuccess(dispatch, message, duration) {
    this.show(
      dispatch,
      message,
      "success",
      duration ? duration : Durations.DefaultSuccessNotification
    );
  }

  showInfo(dispatch, message, duration) {
    this.show(
      dispatch,
      message,
      "info",
      duration ? duration : Durations.DefaultInfoNotification
    );
  }

  showWarning(dispatch, message, duration) {
    this.show(
      dispatch,
      message,
      "warning",
      duration ? duration : Durations.DefaultWarningNotification
    );
  }

  showError(dispatch, message, duration) {
    this.show(
      dispatch,
      message,
      "error",
      duration ? duration : Durations.DefaultErrorNotification
    );
  }
}

export default new NotificationHelperService();
